<app-ssdf-call-filters-dashboard
        class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 w-full"
        [filterDates]="filterDates"
        [selectedDashboardView]="selectedDashboardView"
        [selectedDateFilter]="selectedDateFilter"
        [showDashboardViewMenu]="true"
        (onChangeDateFilterState)="changeDateFilterState($event)"
        (onChangeDashboardView)="changeDashboardView($event)"
></app-ssdf-call-filters-dashboard>

<app-ssdf-call-dashboard-overview
        *ngIf="selectedDashboardView === 'Overview'"
        [appForRegion]="appForRegion"
        [applicationList]="applicationList"
        [appForPremoney]="appForPremoney"
        [appForDay]="appForDay"
        [appForTrl]="appForTrl"
        [fundingNeedBarData]="fundingNeedBarData"
        [originationData]="originationData"
        [patentsData]="patentsData"
        [labNeededData]="labNeededData"
        [zoneData]="zoneData"
        [formedCompanyData]="formedCompanyData"
        [batchData]="batchData"
        [generalData]="generalData"
        [fundingNeedPieData]="fundingNeedPieData"
        [countryData]="countryData"

></app-ssdf-call-dashboard-overview>

<app-ssdf-call-dashboard-batch
        *ngIf="selectedDashboardView === 'Batch'"
        [appForRegion]="appForRegion"
        [appForPremoney]="appForPremoney"
        [appForDay]="appForDay"
        [fundingNeedBarData]="fundingNeedBarData"
        [batchData]="batchData"
        [generalData]="generalData"
        [fundingNeedPieData]="fundingNeedPieData"

></app-ssdf-call-dashboard-batch>

<app-ssdf-call-dashboard-economics
        *ngIf="selectedDashboardView === 'Economics'"
        [appForRegion]="appForRegion"
        [appForPremoney]="appForPremoney"
        [fundingNeedBarData]="fundingNeedBarData"
        [fundingNeedPieData]="fundingNeedPieData"

></app-ssdf-call-dashboard-economics>

<app-ssdf-call-dashboard-others
        *ngIf="selectedDashboardView === 'Altro'"
        [appForRegion]="appForRegion"
        [applicationList]="applicationList"
        [fundingNeedPieData]="fundingNeedPieData"
        [formedCompanyData]="formedCompanyData"
        [zoneData]="zoneData"
        [labNeededData]="labNeededData"
        [patentsData]="patentsData"
        [originationData]="originationData"
        [appForTrl]="appForTrl"
        [countryData]="countryData"

></app-ssdf-call-dashboard-others>
